export const periods = [
  { period: 'Ayer' },
  { period: 'Últimos 7 días' },
  { period: 'Últimos 28 días' },
  { period: 'Personalizado' },
];
